<script lang="ts">
	interface Props {
		className?: string;
	}

	let { className = '' }: Props = $props();
</script>

<div class={className}>
	<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M2.25 12C2.25 6.61554 6.61554 2.25 12 2.25C14.5699 2.25 16.9004 3.25246 18.6394 4.87324C18.7883 5.01197 18.8744 5.20524 18.878 5.4087C18.8816 5.61216 18.8023 5.80834 18.6584 5.95223L16.1128 8.49788C15.8319 8.77876 15.3807 8.79193 15.084 8.52792C14.2608 7.79565 13.1837 7.35 12 7.35C9.43206 7.35 7.35 9.43206 7.35 12C7.35 14.5679 9.43206 16.65 12 16.65C13.6238 16.65 15.0521 15.8153 15.8828 14.55H12C11.5858 14.55 11.25 14.2142 11.25 13.8V10.2C11.25 9.78579 11.5858 9.45 12 9.45H20.8249C21.183 9.45 21.4911 9.70305 21.5607 10.0543C21.6832 10.6728 21.75 11.348 21.75 12C21.75 17.3845 17.3845 21.75 12 21.75C6.61554 21.75 2.25 17.3845 2.25 12ZM12 3.75C7.44396 3.75 3.75 7.44396 3.75 12C3.75 16.556 7.44396 20.25 12 20.25C16.556 20.25 20.25 16.556 20.25 12C20.25 11.6525 20.2275 11.2961 20.1853 10.95H12.75V13.05H17.0864C17.3299 13.05 17.5583 13.1683 17.6988 13.3671C17.8394 13.566 17.8746 13.8208 17.7933 14.0503C16.9491 16.4346 14.6795 18.15 12 18.15C8.60364 18.15 5.85 15.3964 5.85 12C5.85 8.60364 8.60364 5.85 12 5.85C13.3133 5.85 14.5272 6.26519 15.5236 6.96571L17.0229 5.46644C15.6306 4.39163 13.8918 3.75 12 3.75Z"
			fill="currentColor"
		></path>
	</svg>
</div>
